import tasPink from '../../assets/img/tas-pink/tas-pink.png';
import dompetCoklat from '../../assets/img/dompet-coklat/dompet-coklat.png';
import sofaIjo from '../../assets/img/sofa-ijo/sofa-ijo.png';

import sabunMuka from '../../assets/img/sabun-muka/sabun-muka.png';
import sabunBatang from '../../assets/img/sabun-batang/sabun-batang.png';
import kursiPutih from '../../assets/img/kursi-putih/kursi-putih.png';

const initialHighlightState = {
  productPerCategory: {
    categories: [
      {
        id: 'aksesosris-wanita',
        title: 'Aksesoris Wanita',
        img: tasPink,
        url: ''
      },
      {
        id: 'dompet-coklat',
        title: 'Aksesoris Pria',
        img: dompetCoklat,
        url: ''
      },
      {
        id: 'perabotan-rumah-tangga',
        title: 'Perabotan Rumah Tangga',
        img: sofaIjo,
        url: ''
      }
    ]
  },
  todaysPromo: {
    items: [
      {
        id: 'white-skin-cream-whitening',
        name: 'White Skin Cream Whitening',
        qty: 21,
        discount: '70%',
        discountPrice: 100000,
        actualPrice: 30000,
        img: sabunMuka
      },
      {
        id: 'pink-soap',
        name: 'Pink Soap',
        qty: 78,
        discount: '50%',
        discountPrice: 30000,
        actualPrice: 15000,
        img: sabunBatang
      },
      {
        id: 'sofa-klasik-putih',
        name: 'Sofa Klasik Putih',
        qty: 1,
        discount: '30%',
        discountPrice: 3000000,
        actualPrice: 2100000,
        img: kursiPutih
      },
      {
        id: 'dompet-kulit-pria',
        name: 'Dompet Kulit Pria',
        qty: 3,
        discount: '50%',
        discountPrice: 248000,
        actualPrice: 124000,
        img: dompetCoklat
      }
    ]
  }
}

const highlightReducer = (state = initialHighlightState, action) => {
  return state;
}

export default highlightReducer;